import { FunctionComponent, HTMLAttributes } from "react";
import * as Styled from "./accordion-group.style";

export const AccordionGroup: FunctionComponent<
	HTMLAttributes<HTMLDivElement>
> = (props) => {
	const { children } = props;
	return (
		<Styled.AccordionGroupRoot {...props}>{children}</Styled.AccordionGroupRoot>
	);
};
